// extracted by mini-css-extract-plugin
module.exports = {"appointmentCard":"appointment-card_appointmentCard__gvIUg","date":"appointment-card_date__NAQ_R","doctorIcon":"appointment-card_doctorIcon__wvJHW"};